import axios from "axios"

type SearchPoint = {
    street: string
    zipcode: string
    citycode: string
    name?: string
    siret?: string
    lastname?: string
}

type SearchPdlResponse = {
    name: string
    idsource: string
    etat_contractuel: string
    address_normalise: string
}

export class EnedisService {
    /**
     * Recherche des points de livraison pour un particulier
     * @param params - Paramètres de recherche
     * @returns - Liste des points de livraison trouvés
     */
    async searchPoint(params: SearchPoint): Promise<SearchPdlResponse> {
        try {
            const { data: point } = await axios.get(
                "/api/enedis/rechercher_point/particulier",
                {
                    params,
                }
            )
            return {
                name: point?.nomClientFinalOuDenominationSociale,
                idsource: point?.id,
                etat_contractuel: point?.etatContractuel,
                address_normalise: Object.values(
                    point?.adresseInstallationNormalisee
                )
                    ?.join(" ")
                    .trim(),
            }
        } catch (e: any) {
            throw new Error(e?.response?.data?.detail?.message || e?.message)
        }
    }
}

export type { SearchPoint, SearchPdlResponse }
